<template>
    <div>
        <!-- Modal -->
        <div id="salesBehaviorModal" class="modal fade" role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">{{ form.name ? form.name : 'New Sales Activities' }}</h4>
                        <button type="button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @keydown="form.errors.clear($event.target.name)">
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="name"
                                       :class="{'text-red': form.errors.has('name')}">Name</label>
                                <input v-model="form.name" id="name" name="name"
                                       class="appearance-none bg-grey-lightest border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                       :class="{'border-red': form.errors.has('name')}">
                                <div class="text-red text-xs" v-if="form.errors.has('name')">{{ form.errors.get('name')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="value"
                                       :class="{'text-red': form.errors.has('value')}">Value</label>
                                <input v-model="form.value" id="value" name="value" type="number"
                                       @input="form.errors.clear('value')"
                                       class="appearance-none bg-grey-lightest border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                       :class="{'border-red': form.errors.has('value')}">
                                <div class="text-red text-xs" v-if="form.errors.has('value')">{{
                                    form.errors.get('value') }}
                                </div>
                            </div>
                            <div>
                                <label class="text-sm text-grey-darkest -mb-0" for="load_order"
                                    :class="{'text-red': form.errors.has('load_order')}">Load Order</label>
                                <input v-model="form.load_order" type="number" name="load_order" id="load_order"
                                    @input="form.errors.clear('load_order')"
                                    class="appearance-none bg-grey-lightest border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                    :class="{'border-red': form.errors.has('load_order')}">
                                <div class="text-red text-xs" v-if="form.errors.has('load_order')">
                                    {{ form.errors.get('load_order') }}
                                </div>
                            </div>
                            <div class="flex justify-between mt-4" v-if="!has_proposal_delivered || form.proposal_delivered">
                                <div>
                                    <input type="checkbox" id="proposal_delivered" name="proposal_delivered" true-value="1" false-value="0" v-model="form.proposal_delivered">
                                    <label class="text-sm text-grey-darkest -mb-0" for="proposal_delivered"
                                        :class="{'text-red': form.errors.has('proposal_delivered')}">This is the proposal delivered sales activity</label>
                                    <div class="text-red text-xs" v-if="form.errors.has('proposal_delivered')">{{
                                        form.errors.get('proposal_delivered') }}
                                    </div>
                                </div>
                                <i class="fa fa-info-circle" id="proposal-delivered-tooltip" data-toggle="tooltip" data-placement="bottom" title="
                                    A proposal delivered sales activity is a way to put your project on the pipeline phase alongside with a pipeline sales status.
                                    When it is marked, the bid date will be automatically filled with today's date.
                                    This sales activities milestones will be marked as Proposal Delivered.
                                "></i>
                            </div>
                             <div class="flex justify-between mt-4" v-if="!has_revised_proposal_delivered || form.revised_proposal_delivered">
                                <div>
                                    <input type="checkbox" id="proposal_delivered" name="proposal_delivered" true-value="1" false-value="0" v-model="form.revised_proposal_delivered">
                                    <label class="text-sm text-grey-darkest -mb-0" for="proposal_delivered"
                                        :class="{'text-red': form.errors.has('proposal_delivered')}">This is the revised proposal delivered sales activity</label>
                                    <div class="text-red text-xs" v-if="form.errors.has('proposal_delivered')">{{
                                        form.errors.get('proposal_delivered') }}
                                    </div>
                                </div>
                                <i class="fa fa-info-circle" id="proposal-delivered-tooltip" data-toggle="tooltip" data-placement="bottom" title="
                                    A proposal delivered sales activity is a way to put your project on the pipeline phase alongside with a pipeline sales status.
                                    When it is marked, the bid date will be automatically filled with today's date.
                                    This sales activities milestones will be marked as Proposal Delivered.
                                "></i>
                            </div>
                            <div class="flex justify-between"
                            :class="has_proposal_delivered && !form.proposal_delivered ? 'mt-4' : 'mt-1'"
                            v-if="!has_follow_up || form.follow_up">
                                <div>
                                    <input type="checkbox" id="follow_up" name="follow_up" true-value="1" false-value="0" v-model="form.follow_up">
                                    <label class="text-sm text-grey-darkest -mb-0" for="follow_up"
                                        :class="{'text-red': form.errors.has('follow_up')}">This is the follow up sales activity</label>
                                    <div class="text-red text-xs" v-if="form.errors.has('follow_up')">{{
                                        form.errors.get('follow_up') }}
                                    </div>
                                </div>
                                <i class="fa fa-info-circle" id="proposal-delivered-tooltip" data-toggle="tooltip" data-placement="bottom" title="
                                    A follow up sales activity will create a follow up just like the one on the company contacts and will be shown on the dashboard.
                                    It doesn't need to be checked, you can only replace the date for every meeting.
                                "></i>
                            </div>

                            <div class="flex justify-between"
                                 :class="has_lockable_activity && !form.lockable_activity ? 'mt-4' : 'mt-1'">
                                <div>
                                    <input type="checkbox" id="lockable_activity" name="lockable_activity" true-value="1" false-value="0" v-model="form.lockable_activity">
                                    <label class="text-sm text-grey-darkest -mb-0" for="lockable_activity"
                                           :class="{'text-red': form.errors.has('lockable_activity')}">Lock Activity - only complete once</label>
                                    <div class="text-red text-xs" v-if="form.errors.has('lockable_activity')">{{
                                        form.errors.get('lockable_activity') }}
                                    </div>
                                </div>
                            </div>

                            <div class="flex justify-between mt-4" v-if="!has_comment || form.comment">
                                <div>
                                    <input type="checkbox" id="comment" name="comment" true-value="1" false-value="0" v-model="form.comment">
                                    <label class="text-sm text-grey-darkest -mb-0" for="comment"
                                           :class="{'text-red': form.errors.has('comment')}">Call Log Comment</label>
                                    <div class="text-red text-xs" v-if="form.errors.has('comment')">{{
                                            form.errors.get('comment') }}
                                    </div>
                                </div>
                            </div>

                            <div class="flex justify-between"
                                 :class="has_xscope_take_off_req && !form.xscope_take_off_req ? 'mt-4' : 'mt-1'">
                                <div>
                                    <input type="checkbox" id="xscope_take_off_req" name="xscope_take_off_req" true-value="1" false-value="0" v-model="form.xscope_take_off_req">
                                    <label class="text-sm text-grey-darkest -mb-0" for="xscope_take_off_req"
                                           :class="{'text-red': form.errors.has('xscope_take_off_req')}">This is XScope Take-Off Req. Activity.</label>
                                    <div class="text-red text-xs" v-if="form.errors.has('xscope_take_off_req')">{{
                                        form.errors.get('xscope_take_off_req') }}
                                    </div>
                                </div>
                            </div>


                            <div class="flex justify-between mt-4" >
                                <div>
                                    <input type="checkbox" id="complete_comment" name="complete_comment" true-value="1" false-value="0" v-model="form.complete_comment">
                                    <label class="text-sm text-grey-darkest -mb-0" for="complete_comment"
                                           :class="{'text-red': form.errors.has('complete_comment')}">Require comment when activity is completed</label>
                                    <div class="text-red text-xs" v-if="form.errors.has('complete_comment')">{{
                                            form.errors.get('complete_comment') }}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button @click.prevent="saved"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="data.length > 0" class="text-grey-darkest">
            <div class="text-right">
                <button data-toggle="modal" data-target="#salesBehaviorModal"
                        class="border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:no-underline hover:text-white material-icons p-1 rounded-full text-base text-followup-nav">
                    add
                </button>
            </div>

            <div class="bg-white shadow-md rounded mb-6 mt-1">
                <table class="text-left w-full border-collapse">
                    <thead>
                    <tr>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                            Name
                        </th>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                            Value
                        </th>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                            Load Order
                        </th>
                        <th class="py-2 pl-4 pr-4 bg-grey-lightest border-b border-grey-light"></th>
                    </tr>
                    </thead>
<!--                    <tbody>-->
                    <draggable
                        draggable=".item"
                        handle=".handle"
                        :list="data"
                        tag="tbody"
                        @start="drag = true"
                        @end="onUpdate"
                    >
                            <tr @click="editSalesBehavior(item)" class="hover:bg-grey-lighter cursor-pointer item handle"
                                v-for="item in data" :key="item.id">
                                <td class="pl-4 py-2 border-b border-grey-light text-xs">
                                    {{ item.name }} {{ item.proposal_delivered ? '(proposal delivered)' : '' }} {{ item.follow_up ? '(follow up)' : ''}}
                                </td>
                                <td class="pl-4 py-2 border-b border-grey-light text-xs">
                                    {{ item.value }}
                                </td>
                                <td class="pl-4 py-2 border-b border-grey-light text-xs">
                                    {{ item.load_order }}
                                </td>
                                <td class="px-4 py-2 border-b border-grey-light text-right">
                                    <button @click.stop="editSalesBehavior(item)"
                                            class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer">
                                        edit
                                    </button>
                                    <button v-if="!item.proposal_delivered" @click.stop="deleteSalesBehavior(item)"
                                            class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer">
                                        delete
                                    </button>
                                </td>
                            </tr>
                    </draggable>
<!--                    </tbody>-->
                </table>
            </div>
        </div>
        <div v-else-if="data_loading" class="text-5xl text-grey-darkest text-center mt-32">
            <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
        </div>
        <div v-else class="mt-10 text-center">
            <div class="flex-col">
                <div>
                    <img width="400" src="/images/blank.svg">
                </div>
                <div class="mt-4">
                    <div class="text-lg text-grey-darkest mb-2 flex justify-center">
                        <div class="text-xl w-1/4 tracking-wide">You haven't created a sales activity yet!</div>
                    </div>
                    <button @click="addSalesBehavior"
                            class="bg-followup-nav px-4 py-2 rounded-full text-white focus:outline-none hover:bg-followup-nav-darker text-xl">
                        Click here to add your first sales activity!
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Form from "../../utils/form";
    import draggable from 'vuedraggable';

    export default {
        name: 'sales-behaviors',

        data() {
            return {
                data: '',
                data_loading: true,
                current_sales_behavior: null,
                editing: false,
                form: new Form({
                    name: '',
                    value: '',
                    load_order: '',
                    proposal_delivered: false,
                    revised_proposal_delivered: false,
                    follow_up: false,
                    lockable_activity: false,
                    comment:false,
                    xscope_take_off_req: false,
                    complete_comment: false
                }),
                has_proposal_delivered: false,
                has_revised_proposal_delivered: false,
                has_follow_up: false,
                has_lockable_activity: false,
                has_comment:false,
                has_xscope_take_off_req: false,
                has_complete_comment:false,
            }
        },

        created() {
            this.fetchData();
        },

        mounted() {
            let self = this;
            $("#salesBehaviorModal").on('hidden.bs.modal', function () {
                self.form.fullReset();
                self.editing = false;
            });
        },

        methods: {
            fetchData() {
                this.data_loading = true;
                let self = this;
                axios.get(route('settings.sales-behavior.index')).then(({data}) => {
                    self.data = data.data;
                    self.data_loading = false;
                    self.has_proposal_delivered = data.hasProposalDelivered;
                    self.has_revised_proposal_delivered = data.hasRevisedProposalDelivered;
                    self.has_follow_up = data.hasFollowUp;
                    self.has_lockable_activity = data.hasLockableActivity;
                    self.has_comment = data.hasComment;
                    self.has_xscope_take_off_req = data.hasXscopeTakeOffReq;
                    this.onUpdate(self.data);
                });
            },

            saved() {
                let self = this;
                if (self.editing) {
                    this.form.put(route('api.settings.sales-behavior.update', {salesBehavior: this.current_sales_behavior.id})).then(() => {
                        $("#salesBehaviorModal").modal("hide");
                        self.fetchData();
                    });
                } else {
                    this.form.post(route('api.settings.sales-behavior.store')).then(() => {
                        $("#salesBehaviorModal").modal("hide");
                        self.fetchData();
                    });
                }
            },

            addSalesBehavior() {
                $("#salesBehaviorModal").modal("show");
                $(function () {
                    $('[data-toggle="tooltip"]').tooltip();
                });
            },

            editSalesBehavior(item) {
                $("#salesBehaviorModal").modal("show");
                $(function () {
                    $('[data-toggle="tooltip"]').tooltip();
                });

                this.current_sales_behavior = item;
                this.editing = true;
                Object.assign(this.form, item);
            },

            deleteSalesBehavior(item) {
                let self = this;
                Swal.fire({
                    title: "Are you sure?",
                    text: `You're about to delete ${item.name}. Once deleted, this sales activity and all scheduled activities associated with this sales activity will be deleted.`,
                    icon: "warning",
                    buttons: true,
                    dangerMode: true,
                    showCancelButton: true,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText: 'Delete Sales Activity',
                    closeOnConfirm: false,
                    closeOnCancel: true,
                }).then((result) => {
                    if (result.value) {
                        self.form.delete(route('api.settings.sales-behavior.destroy', {salesBehavior: item.id})).then(() => {
                            Swal.fire({
                                title: "Success!",
                                text: "Your sales activity has been deleted!",
                                confirmButtonColor: '#01B1AF',
                                confirmButtonText: 'Ok!',
                                closeOnConfirm: true,
                            }).then(() => {
                                $("#salesBehaviorModal").modal("hide");
                                self.fetchData();
                            });
                        });
                    }
                });
            },

            onUpdate(item){
                let self = this;
                self.data.forEach((SaleBehavior, index) => {
                    SaleBehavior.load_order = index;
                });
                axios.put(route('settings.sales-behavior.order'), this.data);
            }
        },
        components: {
            draggable,
        },
    }
</script>
